import React from 'react';
import { Label, Message, SemanticCOLORS } from 'semantic-ui-react';

import { RecipientBiometryMetaDTO } from '../../../services/standalone-charges';
import {
  biometryPendingCopy,
  biometryRejectedCopy,
  formatAttemptCounter
} from '../utils/biometryCopy';

type Variant = 'pending' | 'rejected' | 'support' | 'limitReached';

type Props = {
  variant: Variant;
  meta?: RecipientBiometryMetaDTO | null;
  compact?: boolean;
  children?: React.ReactNode;
};

const variantConfig: Record<
  Variant,
  { color: SemanticCOLORS; header: string; description: string }
> = {
  pending: {
    color: 'blue',
    header: biometryPendingCopy.title,
    description: biometryPendingCopy.description
  },
  rejected: {
    color: 'red',
    header: biometryRejectedCopy.title,
    description: biometryRejectedCopy.description
  },
  support: {
    color: 'orange',
    header: 'Análise necessária',
    description: biometryRejectedCopy.supportRequired
  },
  limitReached: {
    color: 'red',
    header: biometryRejectedCopy.title,
    description: biometryRejectedCopy.limitReached
  }
};

const BiometryStatusCard: React.FC<Props> = ({ variant, meta, compact, children }) => {
  const config = variantConfig[variant];
  const showAttemptCounter =
    meta?.recipientAttemptCount !== undefined && variant !== 'pending';

  return (
    <Message
      negative={variant === 'rejected' || variant === 'limitReached'}
      warning={variant === 'support'}
      info={variant === 'pending'}
      role="alert"
      style={compact ? { marginBottom: 12 } : undefined}
    >
      <Message.Header>{config.header}</Message.Header>
      <p style={{ marginBottom: showAttemptCounter ? 8 : 12 }}>{config.description}</p>
      {showAttemptCounter && (
        <div style={{ marginBottom: 12 }}>
          <Label color={config.color} size="small">
            {formatAttemptCounter(
              meta?.recipientAttemptCount,
              meta?.maxRecipientAttempts
            )}
          </Label>
        </div>
      )}
      {children}
    </Message>
  );
};

export default BiometryStatusCard;
